import React from "react";

export default function Country({ country }) {
  return <option value={country}>{country}</option>;
}
